import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import appTheme from './theme/theme';
import AnimatedRoutes from 'components/AnimatedRoutes';
import 'swiper/css';
import './swiper.css';
import AuthCookieProvider from 'utils/AuthCookieProvider';
import { ErrorBoundary } from 'components/ErrorBoundary';

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <ErrorBoundary>
        <AuthCookieProvider>
          <Suspense fallback={<></>}>
            <BrowserRouter>
              <AnimatedRoutes />
            </BrowserRouter>
          </Suspense>
        </AuthCookieProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
